// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-points-size {
  width: 480px;
}
.dialog-points-size__title-icon {
  margin: 0 4px 2px 0;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-points-size__row {
  display: flex;
  height: 28px;
  margin-bottom: 40px;
}
.dialog-points-size__row:last-child {
  margin-bottom: 20px;
}
.dialog-points-size__row-label {
  display: flex;
  align-items: center;
  width: 85px;
  margin-right: 20px;
}
.dialog-points-size__range-input {
  flex: 1 1 auto;
}
.dialog-points-size .dl-range-input-picker__range-info-items-list {
  top: 36px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogPointsSize.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACR;AAEI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;AAAR;AAEQ;EACI,mBAAA;AAAZ;AAII;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAFR;AAKI;EACI,cAAA;AAHR;AAMI;EACI,SAAA;AAJR","sourcesContent":[".dialog-points-size {\n  width: 480px;\n}\n.dialog-points-size__title-icon {\n  margin: 0 4px 2px 0;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dialog-points-size__row {\n  display: flex;\n  height: 28px;\n  margin-bottom: 40px;\n}\n.dialog-points-size__row:last-child {\n  margin-bottom: 20px;\n}\n.dialog-points-size__row-label {\n  display: flex;\n  align-items: center;\n  width: 85px;\n  margin-right: 20px;\n}\n.dialog-points-size__range-input {\n  flex: 1 1 auto;\n}\n.dialog-points-size .dl-range-input-picker__range-info-items-list {\n  top: 36px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
